'use client';

import { StaticImageData } from 'next/image';
import { useEffect, useState } from 'react';

import ImageWithSkeleton from '../image/ImageWithSkeleton';

interface PcWideBannerProps {
  src: StaticImageData | string;
  alt: string;
  className?: string;
}

const PcWideBanner = ({ src, alt, className }: PcWideBannerProps) => {
  const [aspectRatio, setAspectRatio] = useState('1860/560');
  useEffect(() => {
    const image = new Image();
    if (typeof src === 'string') {
      image.src = src;
    } else {
      image.src = src.src;
    }
    image.onload = () => {
      const width = image.width;
      const height = image.height;
      const ratio = `${width}/${height}`;
      setAspectRatio(ratio);
    };
  }, [src]);
  return (
    <article className={`px-[30px] pb-[30px] max-w-[1920px] ${className}`}>
      <figure
        className="w-full relative min-w-[1280px] rounded-[32px] overflow-hidden"
        style={{ aspectRatio }}
      >
        <ImageWithSkeleton src={src} alt={alt} className="object-bottom object-cover" fill />
      </figure>
    </article>
  );
};

export default PcWideBanner;
